// extracted by mini-css-extract-plugin
export default {"container":"index_container__1PXNI","tableWrap":"index_tableWrap__RXQr+"};